import API from "./API";
import axios from "axios";

const Reviews = {

    async getAll(){
        const url = API.url('/admin/reviews');
        return await axios.get(url);
    },

    async answer(data){
        const url = API.url(`/admin/reviews/${data.id}/answered${data.answeredAt ? ('?at=' + data.answeredAt) : ''}`);
        return await axios.put(url);
    }
}

export default Reviews;